import { Component, OnInit } from '@angular/core'
import { Category } from 'depoto-core/src/entities'
import { CategoryTreeType } from '../../../models'
import { CoreService } from '../../../services'
import { ProductDetailService } from '../../../services/product-detail.service'
import { SchemaUtil } from '../../../utils'

@Component({
  selector: 'product-categories',
  templateUrl: './product-categories.component.html',
})
export class ProductCategoriesComponent implements OnInit {
  public categoryTreeTypeEnum = CategoryTreeType
  categories: Category[] = []

  constructor(
    private core: CoreService,
    public productDetailService: ProductDetailService,
  ) {}

  async ngOnInit() {
    await this.getCategories()
    this.productDetailService.loading = false
  }

  async getCategories() {
    this.categories = await this.core.services.category
      .getList({ direction: 'ASC', filters: { hasParent: false } }, SchemaUtil.category)
      .then(result => result.items)
  }

  async updateProductCategories() {
    this.productDetailService.loading = true
    await this.core.services.product.update(this.productDetailService.product)
    this.productDetailService.loading = false
  }

  get product() {
    return this.productDetailService.product
  }

  get loading() {
    return this.productDetailService.loading
  }

  get isCreating() {
    return this.productDetailService.isCreating
  }
}
